export const BSC_CONTENT_PATH = 'research/vehicles/best-selling-cars-data';

export const VEHICLE_VIEW_OPTION = 'vehicle';
export const STATE_VIEW_OPTION = 'state';

export const VIEW_BY_OPTIONS = [
  {
    value: VEHICLE_VIEW_OPTION,
    label: 'Vehicle',
    dataTest: 'vehicle-tab',
  },
  {
    value: STATE_VIEW_OPTION,
    label: 'State',
    dataTest: 'state-tab',
  },
];
